// Recovered compiled webpack factory 25403. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e, t, r, n, o) {
    let i = e[t];
    if (
      (o && o.has(t)
        ? (i = o.get(t))
        : Array.isArray(i)
          ? (i = i.map((e) => encodeURIComponent(e)))
          : "string" == typeof i && (i = encodeURIComponent(i)),
      !i)
    ) {
      let o = "oc" === r;
      if ("c" === r || o)
        return o
          ? { param: t, value: null, type: r, treeSegment: [t, "", r] }
          : {
              param: t,
              value: (i = n
                .split("/")
                .slice(1)
                .flatMap((t) => {
                  var r;
                  let n = a(t);
                  return null != (r = e[n.key]) ? r : n.key;
                })),
              type: r,
              treeSegment: [t, i.join("/"), r],
            };
    }
    return { param: t, value: i, treeSegment: [t, Array.isArray(i) ? i.join("/") : i, r], type: r };
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      PARAMETER_PATTERN: function () {
        return n;
      },
      getDynamicParam: function () {
        return r;
      },
      parseMatchedParameter: function () {
        return o;
      },
      parseParameter: function () {
        return a;
      },
    }));
  let n = /^([^[]*)\[((?:\[[^\]]*\])|[^\]]+)\](.*)$/;
  function a(e) {
    let t = e.match(n);
    return t ? o(t[2]) : o(e);
  }
  function o(e) {
    let t = e.startsWith("[") && e.endsWith("]");
    t && (e = e.slice(1, -1));
    let r = e.startsWith("...");
    return (r && (e = e.slice(3)), { key: e, repeat: r, optional: t });
  }
}
